import { createClient } from "@supabase/supabase-js";
import { SUPABASE_KEY, SUPABASE_URL } from "../config/env";

// Cliente único de Supabase. Guarda y renueva solo la sesión de Auth, y toma la sesión que traen los
// enlaces de los correos (crear o cambiar la contraseña).
export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});
